import { useEffect, useState } from 'react';

type SWCommProps = {
  service: string;
  method: string;
  messageId?: string;
  onResponse?: (data: any) => void;
};

const useSWComm = ({ service, method, onResponse }: SWCommProps) => {
  const [value, setValue] = useState<any>(null);
  useEffect(
    function setupListener() {
      function handleListener(event: MessageEvent<any>) {
        if (
          //          event.data.message_id === messageId &&
          event.data.service === service &&
          event.data.method === method &&
          event.data.data
        ) {
          onResponse?.call(undefined, event.data.data);
          setValue(event.data.data);
        }
      }
      navigator.serviceWorker.addEventListener('message', handleListener);

      return function cleanupListener() {
        navigator.serviceWorker.removeEventListener('message', handleListener);
      };
    },

    [service, method, onResponse]
  );
  return value;
};

export default useSWComm;
